import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    '#containerGridPutAway': {
      MozTransition: 'height .5s',
      msTransition: 'height .5s',
      OTransition: 'height .5s',
      WebkitTransition: 'height .5s',
      transition: 'height .5s',
      height: '100px'
    }
  })
)
